import React, { useEffect, useState } from "react";
import { fetchInvoicesHeaders } from "../Api/VendorInvoice";
import VIMInvoiceGrid from "./VIMInvoiceGrid";
import { FiSearch } from "react-icons/fi";
import { FileText, Clock, CheckCircle, Building2 } from "lucide-react";
import "../Styling/PayrollTheme.css";
import "../Styling/VIMTheme.css";

const VIMInvoicePage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");

  const loadData = async () => {
    try {
      setLoading(true);
      const result = await fetchInvoicesHeaders();
      setData(Array.isArray(result) ? result : []);
    } catch (err) {
      console.error("Fetch headers failed:", err);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const filteredData = data.filter((item) => {
    const matchesSearch =
      !searchTerm ||
      item?.VendorName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item?.InvoiceNumber?.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesStatus =
      !statusFilter ||
      (statusFilter === "Parked"
        ? !!item?.ParkStatus
        : !item?.ParkStatus);

    const invoiceDate = item?.InvoiceDate
      ? item.InvoiceDate.split("T")[0]
      : "";
    const matchesStart = !startDateFilter || invoiceDate >= startDateFilter;
    const matchesEnd = !endDateFilter || invoiceDate <= endDateFilter;

    return matchesSearch && matchesStatus && matchesStart && matchesEnd;
  });

  const totalInvoices = data.length;
  const parkedCount = data.filter((x) => !!x?.ParkStatus).length;
  const pendingCount = data.filter((x) => !x?.ParkStatus).length;
  const uniqueVendors = new Set(data.map((x) => x?.VendorName)).size;

  return (
    <div className="vim-page">

      {/* Header */}
      <div className="vim-page__header">
        <h2 className="vim-page__title">VIM Management</h2>

        <p className="vim-page__subtitle">
          View Invoice headers and item details
        </p>
      </div>

      {/* Summary Label */}
      <div style={{
        padding: "14px 24px 0 24px",
        fontSize: "10px",
        fontWeight: 700,
        color: "#9ca3af",
        textTransform: "uppercase",
        letterSpacing: "0.07em",
        background: "#ffffff",
      }}>
        Invoice Summary
      </div>

      {/* Summary Cards */}
      <div className="resource-dashboard-summary">

        <div className="resource-card highlight">
          <div className="card-row">
            <FileText className="card-icon blue" />
            <div className="card-text">
              <p>Total Invoices</p>
              <h3>{totalInvoices}</h3>
            </div>
          </div>
        </div>

        <div className="resource-card accent">
          <div className="card-row">
            <Clock className="card-icon orange" />
            <div className="card-text">
              <p>Pending</p>
              <h3>{pendingCount}</h3>
            </div>
          </div>
        </div>

        <div className="resource-card">
          <div className="card-row">
            <CheckCircle className="card-icon purple" />
            <div className="card-text">
              <p>Parked</p>
              <h3>{parkedCount}</h3>
            </div>
          </div>
        </div>

        <div className="resource-card">
          <div className="card-row">
            <Building2 className="card-icon gray" />
            <div className="card-text">
              <p>Unique Vendors</p>
              <h3>{uniqueVendors}</h3>
            </div>
          </div>
        </div>

      </div>

      {/* Search + Filters */}
<div className="vim-filter-bar">

<div className="vim-search-box">
  <FiSearch className="vim-search-icon" />

  <input
    type="text"
    placeholder="Search vendor or invoice..."
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
  />
</div>

        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
        >
          <option value="">All Status</option>
          <option value="Parked">Parked</option>
          <option value="Pending">Pending</option>
        </select>

        <input
          type="date"
          value={startDateFilter}
          onChange={(e) => setStartDateFilter(e.target.value)}
        />

        <input
          type="date"
          value={endDateFilter}
          onChange={(e) => setEndDateFilter(e.target.value)}
        />

        <button
          className="clear-filter-btn"
          onClick={() => {
            setSearchTerm("");
            setStatusFilter("");
            setStartDateFilter("");
            setEndDateFilter("");
          }}
        >
          Clear
        </button>

      </div>

      {loading ? (
        <div className="vim-page__loading">
          <span className="vim-page__loading-dot" />
          <span className="vim-page__loading-dot" />
          <span className="vim-page__loading-dot" />
        </div>
      ) : (
        <VIMInvoiceGrid
          data={filteredData}
          reloadInvoices={loadData}
        />
      )}

    </div>
  );
};

export default VIMInvoicePage;